<template>
  <!-- 代理商地址管理 -->
  <div class="index-container">
    <div class="page-title">代理商地址管理</div>
    <el-button type="primary" class="new-add-button" @click="newAdd">新增代理商地址</el-button>
    <div class="condition-box">
      <div class="info-value-box">
        <div class="info-title">
          <span>*</span>关键字：
        </div>
        <el-input placeholder="请输入" v-model="key_word"></el-input>
      </div>
      <el-button size="mini" type="primary" @click="search()">搜索</el-button>
      <el-button size="mini" @click="reset()">重置</el-button>
    </div>
    <el-table border :data="tableData" style="width:100%;overflow:auto;">
      <el-table-column prop="name" label="代理商名称"></el-table-column>
      <el-table-column prop="contact" label="收货人姓名"></el-table-column>
      <el-table-column prop="phone" label="收货人电话"></el-table-column>
      <el-table-column prop="address" label="收货地址"></el-table-column>
      <el-table-column prop="action" label="操作">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="updateInfo(scope.row)">更新</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page.sync="page"
      :page-size="10"
      layout="total, prev, pager, next"
      :total="totalPage"
    ></el-pagination>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="60%"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <div class="info-value-box">
        <div class="info-title">
          <span>*</span>代理商名称：
        </div>
        <el-select :disabled="isEdit" v-model="addInfo.name" placeholder="请选择">
          <el-option
            v-for="item in clientList"
            :key="item.Occ18"
            :label="item.Occ18"
            :value="item.Occ18"
          ></el-option>
        </el-select>
      </div>
      <div class="info-value-box">
        <div class="info-title">
          <span>*</span>收货人姓名：
        </div>
        <el-input placeholder="请输入" v-model="addInfo.contact"></el-input>
      </div>
      <div class="info-value-box">
        <div class="info-title">
          <span>*</span>收货人电话：
        </div>
        <el-input placeholder="请输入" v-model="addInfo.phone"></el-input>
      </div>
      <div class="info-value-box">
        <div class="info-title">
          <span>*</span>收货人地址：
        </div>
        <el-input placeholder="请输入" v-model="addInfo.address"></el-input>
      </div>
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="addConfirm">确 定</el-button>
    </el-dialog>
    <el-dialog title="删除" :close-on-click-modal="false" :visible.sync="deleteVisible" width="30%">
      <div class="delete-text">确认删除吗？</div>
      <el-button @click="deleteVisible = false">取 消</el-button>
      <el-button type="primary" @click="confirmDelete">确 定</el-button>
    </el-dialog>
  </div>
</template>
<script>
import api from '../api/api';
export default {
  data() {
    return {
      tableData: [
        {
          title: '2324353'
        }
      ],
      dialogVisible: false,
      deleteVisible: false,
      addInfo: {
        name: '',
        contact: '',
        phone: '',
        address: ''
      },
      dialogTitle: '新增',
      totalPage: 0,
      page: 1,
      infoId: '',
      key_word: '',
      clientList: [],
      isEdit: false
    };
  },

  mounted() {
    this.getAgent();
    this.getAddressList();
  },
  methods: {
    // 代理商选择
    clientChange() {
      this.keywordsgetList();
    },
    search() {
      this.keywordsgetList();
    },
    reset() {
      this.key_word = '';
      this.keywordsgetList();
    },
    newAdd() {
      this.isEdit = false;
      this.dialogVisible = true;
      this.dialogTitle = '新增';
    },
    updateInfo(item) {
      this.dialogVisible = true;
      this.dialogTitle = '编辑';
      this.addInfo = item;
      this.isEdit = true;
    },
    handleDelete(item) {
      this.infoId = item.id;
      this.deleteVisible = true;
    },
    handleCurrentChange(val) {
      this.page = val;
      this.keywordsgetList();
    },
    cancel() {
      this.keywordsgetList();
      this.dialogVisible = false;
    },
    keywordsgetList() {
      const params = {
        key_word: this.key_word
      };
      api.keywordsgetList(params).then(res => {
        const result = res.data;
        if (result.code === 0) {
          this.tableData = result.data.address;
          this.totalPage = result.data.total;
        } else {
          this.$message.warning(result.msg);
        }
      });
    },
    getAgent() {
      const params = {
        key_word: this.key_word
      };
      api.getAgent(params).then(res => {
        const result = res.data;
        if (result.code === 0) {
          this.clientList = result.data.occ;
        } else {
          this.$message.warning(result.msg);
        }
      });
    },
    addConfirm() {
      if (!this.addInfo.name) {
        this.$message.warning('请选择代理商名称！');
      } else if (!this.addInfo.contact) {
        this.$message.warning('请输入收货人姓名！');
      } else if (!this.addInfo.phone) {
        this.$message.warning('请输入收货人电话！');
      } else if (!this.addInfo.address) {
        this.$message.warning('请输入收货人地址！');
      } else {
        if (this.dialogTitle === '新增') {
          api.addAddress(this.addInfo).then(res => {
            const result = res.data;
            if (result.code === 0) {
              this.$message.success('添加成功！');
              this.getAddressList();
              this.dialogVisible = false;
              Object.keys(this.addInfo).forEach(
                key => (this.addInfo[key] = '')
              );
            } else {
              this.$message.error(result.msg);
            }
          });
          return;
        }
        this.addInfo.id = parseInt(this.addInfo.id);
        api.editAddress(this.addInfo).then(res => {
          const result = res.data;
          if (result.code === 0) {
            this.$message.success('更新成功！');
            this.getAddressList();
            this.dialogVisible = false;
          } else {
            this.$message.error(result.msg);
          }
          Object.keys(this.addInfo).forEach(key => (this.addInfo[key] = ''));
        });
      }
    },
    confirmDelete() {
      api.deleteAddress({ id: this.infoId }).then(res => {
        const result = res.data;
        if (result.code === 0) {
          this.$message.success('删除成功！');
          this.deleteVisible = false;
          this.getAddressList();
        } else {
          this.$message.error(result.error);
        }
      });
    },
    // 查询代理商地址列表
    getAddressList() {
      const params = {
        page: this.page,
        pageSize: 10
      };
      api.getAddress(params).then(res => {
        const result = res.data;
        if (result.code === 0) {
          this.tableData = result.data.address;
          this.totalPage = result.data.total;
        } else {
          this.$message.warning(result.msg);
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.index-container {
  position: relative;
  flex: 1;
  padding: 32px;
  overflow: auto;
  .page-title {
    padding-bottom: 20px;
    font-size: 24px;
  }
  .table-img {
    cursor: pointer;
  }
  .new-add-button {
    position: absolute;
    top: 32px;
    right: 32px;
    height: 30px;
    padding: 0 20px;
    line-height: 30px;
  }
  .img-style {
    display: block;
    height: 300px;
    margin: 0 auto;
  }
  .delete-text {
    padding-bottom: 30px;
  }
  /deep/ {
    .el-select {
      width: 100%;
    }
    .el-dialog__body {
      overflow: auto;
    }
    .el-table .cell {
      max-height: 200px;
      text-align: center;
      overflow: auto;
    }
    .el-pagination {
      padding-top: 20px;
      text-align: right;
      .number,
      .el-pagination__total {
        font-size: 18px;
      }
    }
  }
  .info-value-box {
    padding-bottom: 20px;
  }
  .info-title {
    padding-bottom: 10px;
    font-size: 16px;
    span {
      color: crimson;
    }
  }
}
.condition-box {
  display: flex;
  padding: 30px 0 50px;
  .info-value-box {
    display: flex;
    align-items: center;
    width: 36%;
    margin-right: 20px;
    padding: 0;
  }
  .info-title {
    width: 152px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/agentAddress.vue